var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center","justify-lg":"start"}},[_c('v-skeleton-loader',_vm._b({attrs:{"height":"500px","type":"card"}},'v-skeleton-loader',_vm.attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }